import { createApiQuery } from "hooks/createApiQuery";
import { getConfiguration, getModeConfiguration, getModeDetails } from "./calls";

export const useUtilsModeDetails = createApiQuery(getModeDetails);
export const useUtilsModeConfiguration = createApiQuery(getModeConfiguration);

export const useConfiguration = createApiQuery(getConfiguration);
